import base2 from './base2.repository';
import { axios } from './axios';
import { _url } from '../utils/http.util';

export default {
    myClients: () => base2.get('clients/contractor-documents/my-clients'),
    documentTypes: (clientId) => base2.get('clients/contractor-documents/document-types', { client_id: clientId }),
    myDocuments: (clientId) => base2.get('clients/contractor-documents/my-documents', { client_id: clientId }),
    upload: (formData) => base2.post('clients/contractor-documents/upload', formData),
    download: (id) => axios.get(_url(`clients/contractor-documents/${id}/download`), { responseType: 'blob' }),
};
